import React, { FC, useState } from "react";
import styled from "@emotion/styled";
import { TextField } from "@radix-ui/themes";
import { Button } from "@/components/button";

interface SearchFormProps {
  initialQuery?: string;
  initialOwnerId?: string;
  onSearch: (query: string, ownerId: string) => void;
}

export const UploadedFilesSearchForm: FC<SearchFormProps> = ({
  initialQuery = "",
  initialOwnerId = "",
  onSearch,
}) => {
  const [query, setQuery] = useState<string>(initialQuery);
  const [ownerId, setOwnerId] = useState<string>(initialOwnerId);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSearch(query.trim(), ownerId.trim());
  };

  return (
    <FormContainer onSubmit={handleSubmit}>
      <TextFieldContainer
        placeholder="Search by filename..."
        value={query}
        onChange={e => setQuery(e.currentTarget.value)}
        style={{ flex: 1 }}
      />
      <TextFieldContainer
        placeholder="Owner Space Account ID"
        value={ownerId}
        onChange={e => setOwnerId(e.currentTarget.value)}
        style={{ flex: 1 }}
      />
      <Button type="submit">Search</Button>
    </FormContainer>
  );
};

const FormContainer = styled.form`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
`;

const TextFieldContainer = styled(TextField.Root)`
  max-width: 360px;
`;
